import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    mediaSwiperWrapper: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        background: '#121212',
        zIndex: 1101,
    },
    mediaSwiper: {
        width: '100%',
        height: '100%',
    },
    mediaSlider: {
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    topBar: {
        position: 'absolute',
        top: 8,
        left: 8,
        right: 8,
        zIndex: 1102,
    },
    buttonIcon: {
        color: theme.palette.text.white,
    },
    downloadIcon: {
        height: '20px',
        width: '20px',
    },
    image: {
        maxHeight: '100%',
        maxWidth: '100%',
    },
}));
